import React, { useState } from 'react'
import IncubationImage from '../../../assets/images/incubation.png'
import IncubationApplyBg from '../../../assets/incubationBg.png'
import Navigator from '../../../components/common/Navigator'
import { Button, DialogModal } from '../../../components/common'
import { useNavigate } from 'react-router-dom'
import { FaCaretRight } from 'react-icons/fa'
import { useAuthStore } from '../../../store/authStore'

const CaretRightIcon = FaCaretRight as React.ElementType
export default function IncubationPage() {
  const { authenticated, roleData } = useAuthStore()
  const navigate = useNavigate()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleApplyNow = () => {
    if (authenticated) {
      const roleName = roleData?.name?.trim() || ''

      if (
        roleName === 'schools' ||
        roleName === 'research' ||
        roleName === 'industry_asso'
      ) {
        navigate('/departments/incubation-form')
      } else {
        setIsModalOpen(true) // open modal
      }
    } else {
      navigate('/login')
    }
  }

  return (
    <div className="py-6 lg:w-11/12 mx-auto ">
      <div className="">
        <Navigator title="Incubation" slug="INCUBATION" />
        <h1 className="text-3xl font-semibold text-gray-900">Incubation</h1>
        <p className="text-md text-gray-900 mt-1 pb-4">
          Looking for a space to scale-up your startup?
        </p>
        <hr className="border-t-2 border-primaryBlue " />
      </div>

      <div className="flex flex-col md:flex-row gap-6 mb-4">
        <div className="flex-1 ">
          <div>
            <h2 className="text-lg font-bold text-gray-900 mt-4 text-md">
              Nurturing Growth: KIED’s Incubation Facility for MSMEs
            </h2>
            <p className="mt-2 text-justify text-gray-900">
              The Kerala Institute for Entrepreneurship Development (KIED) is
              proud to offer a state-of-the-art Incubation Facility specifically
              designed to empower MSMEs, Small, and Medium Enterprises (SMEs)
              and aspiring entrepreneurs. Our incubation program provides a
              nurturing environment where innovative business ideas can
              transform into successful, sustainable ventures.
            </p>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">
              What is KIED’s Incubation Facility?
            </h2>
            <p className="mt-2 text-justify text-gray-900 text-md">
              Our incubation facility is more than just a workspace. It’s a
              comprehensive support system tailored to the unique needs of
              early-stage MSMEs. We provide the essential resources, mentorship,
              and networking opportunities required to navigate the challenges
              of launching and scaling a business.
            </p>
          </div>
        </div>

        {/* Image Section */}
        <div className="flex-1 flex lg:justify-end justify-center my-4">
          <img
            src={IncubationImage}
            alt="Incubation"
            className="rounded-md object-cover w-[80%] h-full"
          />
        </div>
      </div>

      <div className="flex justify-center ">
        <div
          className="h-24 flex justify-center lg:w-[50%] md:w-full rounded-xl"
          style={{
            backgroundImage: `url(${IncubationApplyBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="flex h-full items-center justify-between w-full px-8">
            <div>
              {' '}
              <h3 className="text-base font-semibold text-gray-800">
                Apply for Incubation Now
              </h3>
              <p className="text-md text-gray-700">
                Join our Incubation Program to Accelerate Your Startup
              </p>
            </div>
            <div>
              {' '}
              <Button
                outlined
                label="Apply Now"
                onClick={handleApplyNow}
                className=" w-40 hover:text-white text-LightGreen hover:bg-LightGreen border-LightGreen hover:border-LightGreen text-md"
              />
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <DialogModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Permission Required"
          className=""
          body={
            <p className="pb-5">
              You do not have permission to access this form.
            </p>
          }
        />
      )}
      {/* Who Can Benefit Section */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">
          Who Can Benefit?
        </h2>
        <div className="w-full h-[1px] bg-primaryBlue" />
        <p className="text-md text-gray-900">Our Facility is Ideal For:</p>
        <ul className="space-y-2 text-md text-gray-900">
          <li className="flex items-start gap-2">
            <CaretRightIcon className="text-arrrowOrange mt-1" />
            <div>
              <span className="font-semibold text-black">
                Startups And Early-Stage MSMEs:
              </span>
              <span>
                Businesses With Innovative Ideas Or Products Seeking Structured
                Support To Grow.
              </span>
            </div>
          </li>

          <li className="flex items-start gap-2">
            <CaretRightIcon className="text-arrrowOrange mt-1" />
            <div>
              <span className="font-semibold text-black">
                Aspiring Entrepreneurs:
              </span>
              <span>
                Individuals With Viable Business Concepts Looking To Formalize
                And Launch Their Ventures.
              </span>
            </div>
          </li>
          <li className="flex items-start gap-2">
            <CaretRightIcon className="text-arrrowOrange mt-1" />
            <div>
              <span className="font-semibold text-black">
                Businesses Seeking Expansion:
              </span>{' '}
              <span className="text-gray-900">
                Existing MSMEs Looking To Diversify, Innovate, Or Scale Up Their
                Operations.
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}
